export const ProviderDayTimeTypes = {
  MORNING: 'morning',
  AFTERNOON: 'afternoon',
  EVNING: 'evening',
  NIGHT: 'night'
}

export const ProviderDays = {
  SUNDAY: 'sunday',
  MONDAY: 'monday',
  TUESDAY: 'tuesday',
  WEDNESDAY: 'wednesday',
  THURSDAY: 'thursday',
  FRIDAY: 'friday',
  SATURDAY: 'saturday'
}

export const ProviderLanguages = {
  AKAN: 'Akan',
  ALBANIAN: 'Albanian',
  AMHARIC: 'Amharic',
  ARABIC: 'Arabic',
  ARAMAIC: 'Aramaic',
  ARMENIAN: 'Armenian',
  ASSYRIAN: 'Assyrian',
  BENGALI: 'Bengali',
  'BENGALI; BANGLA': 'Bengali; Bangla',
  BULGARIAN: 'Bulgarian',
  BURMESE: 'Burmese',
  CANTONESE: 'Cantonese',
  CATALAN: 'Catalan',
  CEBUANO: 'Cebuano',
  CHINESE: 'Chinese',
  CREOLE: 'Creole',
  CROATIAN: 'Croatian',
  CZECH: 'Czech',
  DANISH: 'Danish',
  DARI: 'Dari',
  DUTCH: 'Dutch',
  EGYPTIAN: 'Egyptian',
  ENGLISH: 'English',
  ESPERANTO: 'Esperanto',
  ESTONIAN: 'Estonian',
  FARSI: 'Farsi',
  FILIPINO: 'Filipino',
  FINNISH: 'Finnish',
  FRENCH: 'French',
  GAELIC: 'Gaelic',
  GEORGIAN: 'Georgian',
  GERMAN: 'German',
  GREEK: 'Greek',
  GUJARATI: 'Gujarati',
  HAITIAN: 'Haitian',
  HAUSA: 'Hausa',
  HEBREW: 'Hebrew',
  HINDI: 'Hindi',
  HINDUSTANI: 'Hindustani',
  HUNGARIAN: 'Hungarian',
  IBO: 'Ibo',
  IGBO: 'Igbo',
  ILOCANO: 'Ilocano',
  INDIAN: 'Indian',
  INDONESIAN: 'Indonesian',
  IRANIAN: 'Iranian',
  ITALIAN: 'Italian',
  JAPANESE: 'Japanese',
  KANNADA: 'Kannada',
  KASHMIRI: 'Kashmiri',
  KOREAN: 'Korean',
  KURDISH: 'Kurdish',
  LADINO: 'Ladino',
  LATIN: 'Latin',
  LATVIAN: 'Latvian',
  LAOTIAN: 'Laotian',
  LITHUANIAN: 'Lithuanian',
  MACEDONIAN: 'Macedonian',
  MALAYALAM: 'Malayalam',
  MARATHI: 'Marathi',
  NEPALI: 'Nepali',
  NORWEGIAN: 'Norwegian',
  ORIYA: 'Oriya',
  PANJABI: 'Panjabi',
  PASHTO: 'Pashto',
  'PASHTO, PUSHTO': 'Pashto, Pushto',
  PERSIAN: 'Persian',
  'PERSIAN (FARSI)': 'Persian (Farsi)',
  POLISH: 'Polish',
  PORTUGUESE: 'Portuguese',
  PUNJABI: 'Punjabi',
  ROMANIAN: 'Romanian',
  RUSSIAN: 'Russian',
  SANSKRIT: 'Sanskrit',
  SCOTTISH_GAELIC: 'Scottish Gaelic',
  SERB: 'Serb',
  SERBIAN: 'Serbian',
  SERBO_CROATIAN: 'Serbo Croatian',
  'SERBO-CROATIAN': 'Serbo-Croatian',
  SHONA: 'Shona',
  SINDHI: 'Sindhi',
  SINHALESE: 'Sinhalese',
  SLOVAK: 'Slovak',
  SLOVENIAN: 'Slovenian',
  SOMALI: 'Somali',
  SPANISH: 'Spanish',
  SWAHILI: 'Swahili',
  SWEDISH: 'Swedish',
  SWISS_GERMAN: 'Swiss German',
  TAGALOG: 'Tagalog',
  TAMIL: 'Tamil',
  TAIWANESE: 'Taiwanese',
  TELUGU: 'Telugu',
  THAI: 'Thai',
  TULU: 'Tulu',
  TURKISH: 'Turkish',
  UKRAINIAN: 'Ukrainian',
  URDU: 'Urdu',
  VIETNAMESE: 'Vietnamese',
  YIDDISH: 'Yiddish',
  YORUBA: 'Yoruba',
  ZULU: 'Zulu'
}

export const MAX_IN_PAGE = 10
export const DEFAULT_PAGE = 1
export const INDIVIDUAL_PROVIDER_TYPE = 'individual'

// TODO: remove this when removing nirvana
export const NHProviderCategories = {
  PCP: 'pcp',
  Specialist: 'specialist',
  'Mental Health': 'mental'
}

export const ProviderCategoriesMap = {
  pcp: 'pcp',
  specialist: 'specialist',
  mental: 'mental/behavioral'
}
export const ProviderCategories = {
  [ProviderCategoriesMap.pcp]: 'pcp',
  [ProviderCategoriesMap.specialist]: 'specialist',
  [ProviderCategoriesMap.mental]: 'mental'
}

export const ProviderPCPTypes = {
  TELEHEALTH: 'telehealth',
  PHYSICAL: 'physical'
}

export const ProviderTiers = {
  'Tier 1': 'antidote_tier_1',
  'Tier 2': 'antidote_tier_2'
}

// Providers Tiers in DB for filtering
export const ProvidersTiersMap = {
  antidote: 'Antidote',
  tier1: 'Tier 1',
  tier2: 'Tier 2'
}

export const CopayTypes = {
  ANTIDOTE: 'Antidote Provider',
  REFERRAL: 'With Antidote Referral',
  QCP: 'QCP Provider'
}

export const ValidStates = {
  OH: 'OH',
  AZ: 'AZ'
}

// Directory states used until the app config response arrives, and if the
// PROVIDERS_SEARCH_SUPPORTED_STATES config row is missing
export const DEFAULT_SUPPORTED_STATES = ['OH', 'AZ']
export const DEFAULT_STATE = 'OH'

// Country for the city lookups in locationUtils. Named apart from COUNTRY_CODES,
// which is the list of phone calling codes.
export const LOCATION_COUNTRY_CODE = 'US'

export const CITY = 'city'
export const ZIPCODE = 'zipcode'
